"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosProductAlertCreateInputSchema = exports.APosProductAlertSchema = exports.APosShelfPullStatusSchema = exports.APosAlertStatusSchema = exports.APosAlertTypeSchema = exports.APosAlertActionSchema = exports.APosAlertSeveritySchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosAlertSeveritySchema = zod_1.z.enum(['critical', 'high', 'medium', 'low']);
exports.APosAlertActionSchema = zod_1.z.enum(['stop_sale', 'warning', 'info']);
exports.APosAlertTypeSchema = zod_1.z.enum([
    'fda_recall', 'manufacturer_recall', 'quality_issue',
    'safety_alert', 'regulatory', 'internal',
]);
exports.APosAlertStatusSchema = zod_1.z.enum(['active', 'resolved', 'expired']);
exports.APosShelfPullStatusSchema = zod_1.z.object({
    status: zod_1.z.enum(['pending', 'pulled', 'confirmed']),
    pulledBy: zod_1.z.string().optional(),
    pulledAt: zod_1.z.number().optional(),
    confirmedBy: zod_1.z.string().optional(),
    confirmedAt: zod_1.z.number().optional(),
    quantityPulled: zod_1.z.number().int().nonnegative().default(0),
    quantityQuarantined: zod_1.z.number().int().nonnegative().default(0),
    quarantineLocation: zod_1.z.string().optional(),
});
exports.APosProductAlertSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    alertId: id_schema_1.EntityIdSchema,
    scope: zod_1.z.enum(['variant', 'product', 'category', 'brand', 'batch']),
    scopeIds: zod_1.z.array(zod_1.z.string()).min(1),
    severity: exports.APosAlertSeveritySchema,
    action: exports.APosAlertActionSchema,
    blockSale: zod_1.z.boolean().default(false),
    requireShelfPull: zod_1.z.boolean().default(false),
    alertType: exports.APosAlertTypeSchema,
    title: zod_1.z.string().min(1).max(200),
    message: zod_1.z.string().min(1).max(2000),
    authority: zod_1.z.string().optional(),
    referenceNumber: zod_1.z.string().optional(),
    externalUrl: zod_1.z.string().url().optional(),
    affectedBatchNumbers: zod_1.z.array(zod_1.z.string()).optional(),
    status: exports.APosAlertStatusSchema.default('active'),
    shelfPullRequired: zod_1.z.boolean().default(false),
    shelfPullStatus: zod_1.z.record(zod_1.z.string(), exports.APosShelfPullStatusSchema).default({}),
    resolvedAt: zod_1.z.number().optional(),
    resolvedBy: zod_1.z.string().optional(),
    resolutionAction: zod_1.z.enum(['restock', 'destroy', 'return_to_supplier']).optional(),
    resolutionNotes: zod_1.z.string().max(2000).optional(),
    notifyCustomers: zod_1.z.boolean().default(false),
    customersNotified: zod_1.z.number().int().nonnegative().default(0),
    notifyEmployees: zod_1.z.boolean().default(true),
    createdBy: id_schema_1.EntityIdSchema,
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosProductAlertCreateInputSchema = zod_1.z.object({
    scope: zod_1.z.enum(['variant', 'product', 'category', 'brand', 'batch']),
    scopeIds: zod_1.z.array(zod_1.z.string()).min(1),
    severity: exports.APosAlertSeveritySchema,
    action: exports.APosAlertActionSchema,
    blockSale: zod_1.z.boolean().optional(),
    requireShelfPull: zod_1.z.boolean().optional(),
    alertType: exports.APosAlertTypeSchema,
    title: zod_1.z.string().min(1).max(200),
    message: zod_1.z.string().min(1).max(2000),
    authority: zod_1.z.string().optional(),
    referenceNumber: zod_1.z.string().optional(),
    externalUrl: zod_1.z.string().url().optional(),
    affectedBatchNumbers: zod_1.z.array(zod_1.z.string()).optional(),
    notifyCustomers: zod_1.z.boolean().optional(),
    notifyEmployees: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=product-alert.schema.js.map